import styled from "styled-components";

export const Container = styled.div``;

export const SVG = styled.svg`
  margin-top: -16px;
  margin-bottom: 32px;
  display: block;
`;
